var _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#CFE92A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0286 13.9945C17.1777 12.8775 17.8084 11.381 17.8084 9.78297C17.8084 8.18495 17.0922 6.51745 15.8469 5.40045C14.6016 4.28878 12.9288 3.75433 11.256 3.94139C8.573 4.24068 6.40311 6.39987 6.08779 9.07749C5.874 10.916 6.50466 12.7118 7.82476 13.9945C8.22026 14.3793 8.45007 14.9298 8.45007 15.5016V16.2018H8.18284C7.8889 16.2018 7.64839 16.4423 7.64839 16.7362C7.64839 17.0302 7.8889 17.2707 8.18284 17.2707H9.25175V18.3396C9.25175 19.2214 9.97326 19.9429 10.8551 19.9429H12.9929C13.8748 19.9429 14.5963 19.2214 14.5963 18.3396V17.2707H15.6652C15.9591 17.2707 16.1997 17.0302 16.1997 16.7362C16.1997 16.4423 15.9591 16.2018 15.6652 16.2018H15.398V15.5016C15.398 14.9298 15.6278 14.3846 16.0233 13.9945H16.0286ZM13.5327 18.3342C13.5327 18.6282 13.2922 18.8687 12.9983 18.8687H10.8605C10.5665 18.8687 10.326 18.6282 10.326 18.3342V17.2653H13.5327V18.3342ZM9.52432 16.1964V15.4963C9.52432 14.6412 9.17693 13.8127 8.57834 13.2248C7.49874 12.172 6.98032 10.7076 7.15669 9.20041C7.41323 7.00915 9.18762 5.24545 11.3789 4.99961C12.7738 4.84461 14.1046 5.26683 15.1414 6.19144C16.1622 7.10535 16.7448 8.40942 16.7448 9.77762C16.7448 11.1458 16.2264 12.3109 15.2911 13.2248C14.6871 13.8127 14.3398 14.6412 14.3398 15.4963V16.1964H9.52967H9.52432Z",
    fill: "#050B29"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4123 9.24844H18.8778C18.5839 9.24844 18.3434 9.48895 18.3434 9.7829C18.3434 10.0768 18.5839 10.3174 18.8778 10.3174H19.4123C19.7062 10.3174 19.9467 10.0768 19.9467 9.7829C19.9467 9.48895 19.7062 9.24844 19.4123 9.24844Z",
    fill: "#050B29"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3435 7.64165C18.4237 7.64165 18.5039 7.62561 18.5841 7.58286L19.653 7.0484C19.9148 6.91479 20.0217 6.59412 19.8935 6.33224C19.7652 6.07035 19.4392 5.96346 19.1773 6.09173L18.1084 6.62618C17.8465 6.7598 17.7396 7.08047 17.8679 7.34235C17.9641 7.52941 18.1511 7.6363 18.3489 7.6363L18.3435 7.64165Z",
    fill: "#050B29"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6528 12.5123L18.5838 11.9778C18.3166 11.8442 17.9959 11.9511 17.8677 12.2183C17.7394 12.4856 17.841 12.8009 18.1082 12.9345L19.1771 13.469C19.2519 13.5064 19.3374 13.5278 19.4176 13.5278C19.6153 13.5278 19.8024 13.4209 19.8986 13.2338C20.0322 12.9719 19.9253 12.6513 19.6581 12.5176L19.6528 12.5123Z",
    fill: "#050B29"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44736 10.3174H4.98181C5.27576 10.3174 5.51626 10.0768 5.51626 9.7829C5.51626 9.48895 5.27576 9.24844 4.98181 9.24844H4.44736C4.15341 9.24844 3.9129 9.48895 3.9129 9.7829C3.9129 10.0768 4.15341 10.3174 4.44736 10.3174Z",
    fill: "#050B29"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75666 6.63415L4.68775 6.0997C4.42053 5.96608 4.09985 6.07297 3.97158 6.3402C3.83797 6.60208 3.94486 6.92276 4.21209 7.05637L5.281 7.59082C5.35582 7.62824 5.44133 7.64961 5.5215 7.64961C5.71925 7.64961 5.90631 7.54272 6.00251 7.35566C6.13612 7.09378 6.02923 6.77311 5.76201 6.6395L5.75666 6.63415Z",
    fill: "#050B29"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27538 11.9799L4.20647 12.5143C3.94459 12.648 3.8377 12.9686 3.96597 13.2305C4.06217 13.4176 4.24923 13.5245 4.44698 13.5245C4.52714 13.5245 4.60731 13.5084 4.68748 13.4657L5.75639 12.9312C6.01827 12.7976 6.12516 12.4769 5.99689 12.215C5.86328 11.9532 5.54261 11.8463 5.28072 11.9745L5.27538 11.9799Z",
    fill: "#050B29"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6024 12.2269C14.8964 12.2269 15.1369 11.9864 15.1369 11.6925V7.90854C15.1369 7.61459 14.8964 7.37409 14.6024 7.37409H14.5116C13.6618 7.37409 12.8815 7.55046 12.1867 7.89785L11.9302 8.02612L11.6736 7.89785C10.9788 7.55046 10.1985 7.36874 9.34876 7.36874H9.2579C8.96395 7.36874 8.72345 7.60925 8.72345 7.9032V11.6871C8.72345 11.9811 8.96395 12.2216 9.2579 12.2216H9.34876C10.1184 12.2216 10.8773 12.4354 11.54 12.8469L11.6469 12.911C11.7324 12.9645 11.8286 12.9912 11.9248 12.9912C12.021 12.9912 12.1172 12.9645 12.2027 12.911L12.3096 12.8469C12.9724 12.4407 13.7313 12.2216 14.5009 12.2216H14.5918L14.6024 12.2269ZM9.79236 8.46437C10.3001 8.51248 10.7704 8.64074 11.1926 8.85453L11.3957 8.95607V11.5749C10.8826 11.3558 10.3428 11.2222 9.79236 11.1741V8.45903V8.46437ZM14.068 11.1794C13.5175 11.2275 12.9724 11.3611 12.4646 11.5802V8.96142L12.6677 8.85987C13.0899 8.64609 13.5603 8.51782 14.068 8.46972V11.1847V11.1794Z",
    fill: "#050B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_20",
    x: 5.44856,
    y: 3.30637,
    width: 12.9581,
    height: 17.2349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_20",
    x: 17.7451,
    y: 8.65012,
    width: 2.79997,
    height: 2.26555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3_20",
    x: 17.2153,
    y: 5.43919,
    width: 3.33067,
    height: 2.80076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_20",
    x: 17.2142,
    y: 11.322,
    width: 3.34025,
    height: 2.80409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3_20",
    x: 3.31458,
    y: 8.65012,
    width: 2.79997,
    height: 2.26555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3_20",
    x: 3.31574,
    y: 5.44386,
    width: 3.34263,
    height: 2.80409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3_20",
    x: 3.31342,
    y: 11.322,
    width: 3.33604,
    height: 2.80076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3_20",
    x: 8.12513,
    y: 6.77042,
    width: 7.61009,
    height: 6.81911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.913725 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallPractice);
export default __webpack_public_path__ + "static/media/icon-small-practice.27051fcb4ee762c37de1151544579d3d.svg";
export { ForwardRef as ReactComponent };